export enum ViewMode {
    NORMAL = 'view-mode-normal',
    BASKET_BUILDER = 'view-mode-basket-builder'
}
